(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hsbd-category-filters"] && !Shopify.designMode) return;
  try {
    function hsbdInitCategoryFilters(root = document) {
  root.querySelectorAll('[data-hsbd-category-filters]').forEach(form => {
    if (form.dataset.initialized) return;
    const grid = form.closest('.hsbd-simply-hub')?.querySelector('.hsbd-hub-results-grid');
    if (!grid) return;
    const parse = value => { try { const list = JSON.parse(value || '[]'); return Array.isArray(list) ? list : []; } catch { return []; } };
    const cards = Array.from(grid.children).filter(card => card.matches('.product-index'));
    const rows = cards.map(card => ({card, colors:parse(card.dataset.hubColors), sizes:parse(card.dataset.hubStockSizes), preSizes:parse(card.dataset.hubPreorderSizes), fabric:card.dataset.hubFabric || '', price:Number(card.dataset.hubPrice)/100}));
    const color = form.elements.namedItem('color');
    const size = form.elements.namedItem('stock_size');
    const fabric = form.elements.namedItem('fabric');
    const tools=form.previousElementSibling;
    const stock=tools.querySelector('[data-category-exclude]');
    const toggle=tools.querySelector('[data-hsbd-category-toggle]');
    toggle.addEventListener('click',()=>{form.hidden=!form.hidden;toggle.setAttribute('aria-expanded',String(!form.hidden));});
    const min = form.elements.namedItem('min');
    const max = form.elements.namedItem('max');
    const status = tools.querySelector('[role=status]');
    const active = tools.querySelector('[data-category-active]');
    const addOptions = (select, values) => values.forEach(value => { const option = document.createElement('option'); option.value=value; option.textContent=String(value).toUpperCase(); select.append(option); });
    addOptions(color, Array.from(new Set(rows.flatMap(row=>row.colors))).sort());
    addOptions(fabric, Array.from(new Set(rows.map(row=>row.fabric).filter(Boolean))).sort());
    const sizeOrder = ['XXS','XS','S','M','L','XL','XXL','XXXL','YOUTH/XXXS','YOUTH'];
    addOptions(size, Array.from(new Set(rows.flatMap(row=>row.sizes.concat(row.preSizes)))).sort((a,b)=>(sizeOrder.indexOf(a)<0?99:sizeOrder.indexOf(a))-(sizeOrder.indexOf(b)<0?99:sizeOrder.indexOf(b))));
    const controls = {hsbd_color:color, hsbd_size:size, hsbd_fabric:fabric, hsbd_min:min, hsbd_max:max};
    const restore = () => {
      const params = new URL(location.href).searchParams;
      Object.entries(controls).forEach(([key, control]) => { control.value = params.get(key) || ''; });
      stock.checked = params.get('hsbd_exclude') === '1';
    };
    function sync() {
      const url = new URL(location.href);
      Object.entries(controls).forEach(([key, control]) => { if(control.value)url.searchParams.set(key,control.value);else url.searchParams.delete(key); });
      if(stock.checked)url.searchParams.set('hsbd_exclude','1');else url.searchParams.delete('hsbd_exclude');
      history.replaceState(null,'',url);
    }
    function chips() {
      active.replaceChildren();
      Object.values(controls).forEach(control => {
        if(!control.value)return;
        const label = control.closest('label').firstChild.textContent.trim();
        const button = document.createElement('button');
        button.type='button';
        button.textContent=label+': '+control.value+' ×';
        button.addEventListener('click',()=>{control.value='';apply();});
        active.append(button);
      });
      if(stock.checked) {
        const button=document.createElement('button');
        button.type='button';
        button.textContent=stock.closest('label').textContent.trim()+' ×';
        button.addEventListener('click',()=>{stock.checked=false;apply();});
        active.append(button);
      }
      if(active.children.length) {
        const clear=document.createElement('button');
        clear.type='button';clear.textContent=active.dataset.clearLabel;
        clear.addEventListener('click',()=>form.reset());
        active.append(clear);
      }
      active.hidden=!active.children.length;
    }
    function apply() {
      let count=0;
      rows.forEach(row=>{
        const visible=(!fabric.value||row.fabric===fabric.value)&&(!color.value||row.colors.includes(color.value))&&(!stock.checked||row.sizes.length>0)&&(!size.value||(stock.checked?row.sizes:row.sizes.concat(row.preSizes)).includes(size.value))&&(min.value===''||row.price>=Number(min.value))&&(max.value===''||row.price<=Number(max.value));
        row.card.hidden=!visible;
        if(visible)count++;
      });
      status.textContent=count?status.dataset.resultTemplate.replace('__HSBDCOUNT__',String(count)):status.dataset.empty;
      chips();
      sync();
    }
    form.addEventListener('submit',event=>event.preventDefault());
    form.addEventListener('change',event=>{
      apply();
    });
    stock.addEventListener('change',apply);
    form.addEventListener('input',event=>{if(event.target===min||event.target===max)apply();});
    form.addEventListener('reset',()=>{stock.checked=false;setTimeout(apply,0);});
    window.addEventListener('popstate',()=>{restore();apply();});
    form.dataset.initialized='true';
    tools.hidden=false;
    restore();
    apply();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>hsbdInitCategoryFilters());
else hsbdInitCategoryFilters();
document.addEventListener('shopify:section:load',event=>hsbdInitCategoryFilters(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-complete-look"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.hsbdShelfReady) return;
      root.dataset.hsbdShelfReady = 'true';
      const track = root.querySelector('[data-hsbd-shelf-track]');
      const controls = root.querySelector('[data-hsbd-shelf-controls]');
      const previous = root.querySelector('[data-hsbd-shelf-prev]');
      const next = root.querySelector('[data-hsbd-shelf-next]');
      if (!track || !controls || !previous || !next) return;
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        controls.hidden = maximum <= 8;
        previous.disabled = track.scrollLeft <= 8;
        next.disabled = track.scrollLeft >= maximum - 8;
      };
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 240), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('focusin', (event) => event.target.closest('.hsbd-pad')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' }));
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    document.querySelectorAll('[data-hsbd-matching-shelf]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-hsbd-matching-shelf]').forEach(initialize));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-day-shirts-hub.before-feature-product-fix-20261020"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.hsbdDayShirtHubBound) return;
  window.hsbdDayShirtHubBound = true;

  function refresh(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-hsbd-day-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-hsbd-day-track]');
      var previous = carousel.querySelector('[data-hsbd-day-scroll="-1"]');
      var next = carousel.querySelector('[data-hsbd-day-scroll="1"]');
      if (!track || !previous || !next) return;
      var update = function() {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      if (!track.dataset.controlsReady) {
        track.dataset.controlsReady = 'true';
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    });
  }

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('.hsbd-day-shirt-hub [data-hsbd-day-scroll]');
    if (!button) return;
    var track = button.closest('[data-hsbd-day-carousel]')?.querySelector('[data-hsbd-day-track]');
    if (!track) return;
    var direction = Number(button.dataset.hsbdDayScroll);
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: motion });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { refresh(document); });
  } else {
    refresh(document);
  }
  document.addEventListener('shopify:section:load', function(event) { refresh(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-day-shirts-hub.before-layout-revision-20261020"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.hsbdDayShirtHubBound) return;
  window.hsbdDayShirtHubBound = true;

  function refresh(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-hsbd-day-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-hsbd-day-track]');
      var previous = carousel.querySelector('[data-hsbd-day-scroll="-1"]');
      var next = carousel.querySelector('[data-hsbd-day-scroll="1"]');
      if (!track || !previous || !next) return;
      var update = function() {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      if (!track.dataset.controlsReady) {
        track.dataset.controlsReady = 'true';
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    });
  }

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('.hsbd-day-shirt-hub [data-hsbd-day-scroll]');
    if (!button) return;
    var track = button.closest('[data-hsbd-day-carousel]')?.querySelector('[data-hsbd-day-track]');
    if (!track) return;
    var direction = Number(button.dataset.hsbdDayScroll);
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: motion });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { refresh(document); });
  } else {
    refresh(document);
  }
  document.addEventListener('shopify:section:load', function(event) { refresh(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-day-shirts-hub"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.hsbdDayShirtHubBound) return;
  window.hsbdDayShirtHubBound = true;

  function refresh(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-hsbd-day-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-hsbd-day-track]');
      var previous = carousel.querySelector('[data-hsbd-day-scroll="-1"]');
      var next = carousel.querySelector('[data-hsbd-day-scroll="1"]');
      if (!track || !previous || !next) return;
      var update = function() {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      if (!track.dataset.controlsReady) {
        track.dataset.controlsReady = 'true';
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    });
  }

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('.hsbd-day-shirt-hub [data-hsbd-day-scroll]');
    if (!button) return;
    var track = button.closest('[data-hsbd-day-carousel]')?.querySelector('[data-hsbd-day-track]');
    if (!track) return;
    var direction = Number(button.dataset.hsbdDayScroll);
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: motion });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { refresh(document); });
  } else {
    refresh(document);
  }
  document.addEventListener('shopify:section:load', function(event) { refresh(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-finishing-options"] && !Shopify.designMode) return;
  try {
    (function () {
  function submitFinishingForm(event) {
    const target = event.target instanceof Element ? event.target : null;
    const button = event.type === 'click' ? target?.closest('.js-ajax-submit') : event.submitter;
    const form = event.type === 'submit' ? target : button?.closest('form');
    if (form?.matches('.hsbd-native-reorder__form')) return;
    if (!form?.querySelector('.js-hsbd-panty-panel')) return;
    const configElement = document.getElementById('cart-config');
    if (!configElement || !window.Shopify?.theme?.ajaxCart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const originalButton = form.querySelector('.js-ajax-submit:not(.gpo-clone-atc-button)');
    if (!originalButton || originalButton.disabled) return;
    form.querySelectorAll('.gpo-clone-atc-button').forEach(clone => {
      clone.classList.remove('js-ajax-submit');
    });
    const config = JSON.parse(configElement.textContent || '{}');
    const quickview = Boolean(form.closest('.js-quickview-content'));
    window.Shopify.theme.ajaxCart.addToCart(form, form, config, quickview);
  }
  window.addEventListener('click', submitFinishingForm, true);
  window.addEventListener('submit', submitFinishingForm, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-launch-shop-navigation"] && !Shopify.designMode) return;
  try {
    function hsbdInitMegaMenus(root=document) {
  root.querySelectorAll('[data-hsbd-mega]').forEach(parent=>{
    if(parent.dataset.megaReady) return;
    parent.dataset.megaReady='true';
    const button=parent.querySelector('.hsbd-mega-toggle'),panel=parent.querySelector('.hsbd-mega'),bridge=parent.querySelector('.hsbd-mega-bridge');
    let ignoreFocus=false,closeTimer;
    function position() {
      const header=parent.closest('header')||parent.closest('[data-section-type]')||parent;
      const top=Math.max(0,header.getBoundingClientRect().bottom);
      const bridgeTop=Math.max(0,parent.querySelector('.hsbd-mega-trigger').getBoundingClientRect().bottom);
      bridge.style.setProperty('--hsbd-bridge-top',bridgeTop+'px');
      bridge.style.setProperty('--hsbd-bridge-height',Math.max(0,top-bridgeTop)+'px');
      panel.style.setProperty('--hsbd-mega-top',top+'px');
      panel.style.setProperty('--hsbd-mega-height',Math.max(180,innerHeight-top-16)+'px');
    }
    function setOpen(open) { clearTimeout(closeTimer); if(open) position(); panel.hidden=!open; bridge.hidden=!open; button.setAttribute('aria-expanded',String(open)); }
    parent.addEventListener('mouseenter',()=>setOpen(true));
    parent.addEventListener('mouseleave',()=>{closeTimer=setTimeout(()=>{if(!parent.matches(':hover')&&!parent.contains(document.activeElement))setOpen(false)},450)});
    panel.addEventListener('mouseenter',()=>clearTimeout(closeTimer));
    bridge.addEventListener('mouseenter',()=>clearTimeout(closeTimer));
    parent.addEventListener('focusin',event=>{if(!ignoreFocus&&event.target!==button)setOpen(true)});
    parent.addEventListener('focusout',event=>{if(!parent.contains(event.relatedTarget))setOpen(false)});
    button.addEventListener('click',event=>{event.preventDefault();setOpen(true)});
    parent.querySelector('[data-hsbd-mega-close]').addEventListener('click',()=>{setOpen(false);ignoreFocus=true;button.focus();ignoreFocus=false});
    parent.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();setOpen(false);ignoreFocus=true;button.focus();ignoreFocus=false}});
    document.addEventListener('click',event=>{if(!parent.contains(event.target))setOpen(false)});
    window.addEventListener('resize',()=>setOpen(false));
    window.addEventListener('scroll',()=>{if(!panel.hidden)position()},{passive:true});
  });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>hsbdInitMegaMenus()); else hsbdInitMegaMenus();
document.addEventListener('shopify:section:load',event=>hsbdInitMegaMenus(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-matching-shirts"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.hsbdShelfReady) return;
      root.dataset.hsbdShelfReady = 'true';
      const track = root.querySelector('[data-hsbd-shelf-track]');
      const controls = root.querySelector('[data-hsbd-shelf-controls]');
      const previous = root.querySelector('[data-hsbd-shelf-prev]');
      const next = root.querySelector('[data-hsbd-shelf-next]');
      if (!track || !controls || !previous || !next) return;
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        controls.hidden = maximum <= 8;
        previous.disabled = track.scrollLeft <= 8;
        next.disabled = track.scrollLeft >= maximum - 8;
      };
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 240), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('focusin', (event) => event.target.closest('.hsbd-pad')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' }));
      window.addEventListener('resize', update, { passive: true });
      update();
    };
    document.querySelectorAll('[data-hsbd-matching-shelf]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-hsbd-matching-shelf]').forEach(initialize));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-native-reorder"] && !Shopify.designMode) return;
  try {
    async function hsbdSubmitReorder(event) {
  const target = event.target;
  const form = event.type === 'submit' ? target : (target instanceof Element ? target.closest('.hsbd-native-reorder__form button[type="submit"]')?.form : null);
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('hsbd-native-reorder__form')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (!form.reportValidity() || form.dataset.submitting === 'true') return;
  const panel = form.closest('.hsbd-native-reorder');
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('.hsbd-native-reorder__error');
  form.dataset.submitting = 'true';
  button.disabled = true;
  error.hidden = true;
  try {
    const panelChoice = form.querySelector('.js-hsbd-panty-panel');
    const needsPanel = panelChoice?.value === 'YES' || window.HSBDPanelCart?.hasPending(form);
    if (needsPanel) {
      if (!window.HSBDPanelCart?.addFromForm) throw new Error('Finishing options are not ready. Refresh the page before adding your reorder.');
      await window.HSBDPanelCart.addFromForm(form);
    } else {
      const response = await fetch(panel.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this reorder. Please try again.');
    }
    window.location.assign(panel.dataset.cartUrl);
  } catch (failure) {
    error.textContent = failure.message;
    error.hidden = false;
    form.dataset.submitting = 'false';
    button.disabled = false;
  }
}
window.addEventListener('click', hsbdSubmitReorder, true);
window.addEventListener('submit', hsbdSubmitReorder, true);
document.addEventListener('click', event => {
  const link = event.target.closest('[data-hsbd-open-timeline]');
  if (!link) return;
  const details = document.getElementById(link.hash.slice(1));
  if (!(details instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  details.open = true;
  details.scrollIntoView({ block: 'start', behavior: 'smooth' });
  details.querySelector('summary')?.focus({ preventScroll: true });
}, true);
(function () {
  function init(scope) {
    scope.querySelectorAll('.hsbd-native-reorder').forEach(panel => {
      const detailsOwner = panel.closest('.product__section-details');
      if (detailsOwner && !panel.dataset.orderRouteReady) {
        const updateRoute = (event) => {
          const sizeSelect = panel.querySelector('select[name="properties[Requested size]"]');
          const changed = event?.target;
          const isMainSize = input => input instanceof HTMLInputElement
            && input.matches('.swatches__form--input')
            && !panel.contains(input)
            && (input.closest('.hsbd-petite-sizes') || input.name.toLowerCase() === 'size');
          if (event && !isMainSize(changed)) return;
          const selected = Array.from(detailsOwner.querySelectorAll('.swatches__form--input:checked')).find(isMainSize);
          if (!selected || !sizeSelect) return;
          const matched = Array.from(sizeSelect.options).find(option => option.value && option.value.toUpperCase() === selected.value.toUpperCase());
          if (matched) sizeSelect.value = matched.value;
          const isMadeToOrder = selected.closest('.hsbd-size-tile--made_to_order') !== null;
          if (/re[ -]?order/i.test(selected.value) || (matched && isMadeToOrder)) panel.open = true;
        };
        detailsOwner.addEventListener('change', updateRoute);
        detailsOwner.addEventListener('click', event => {
          const label = event.target instanceof Element ? event.target.closest('label.swatches__form--label') : null;
          if (!label || panel.contains(label)) return;
          const input = document.getElementById(label.htmlFor);
          const sizeSelect = panel.querySelector('select[name="properties[Requested size]"]');
          if (!(input instanceof HTMLInputElement) || !sizeSelect) return;
          const matched = Array.from(sizeSelect.options).find(option => option.value && option.value.toUpperCase() === input.value.toUpperCase());
          if (!matched) return;
          sizeSelect.value = matched.value;
          if (label.querySelector('.hsbd-option-status--made_to_order')) panel.open = true;
        }, true);
        panel.dataset.orderRouteReady = 'true';
        updateRoute();
      }
      const stockDetails = panel.previousElementSibling;
      if (!stockDetails?.matches('.hsbd-reorder-stock-details') || stockDetails.dataset.ready) return;
      const owner = panel.closest('.product__section-details__inner');
      const siblings = owner?.parentElement;
      const variants = siblings?.querySelector('.product__section-details__inner--product_variants');
      const stockForm = owner?.querySelector('.product__form-buttons');
      const content = stockDetails.querySelector('.hsbd-reorder-stock-content');
      if (!variants || !stockForm || !content) return;
      content.append(variants, stockForm);
      stockDetails.dataset.ready = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-pad-base-controls"] && !Shopify.designMode) return;
  try {
    function hsbdInitNativePadBase(root=document) {
  root.querySelectorAll('[data-pad-base-controls]').forEach(control=>{
    if(control.dataset.initialized) return;
    const owner=control.closest('#CollectionProductGrid'),grid=owner?.querySelector('#main-collection-product-grid');
    if(!grid) return;
    control.dataset.initialized='true';control.hidden=false;
    const select=control.querySelector('select'),status=control.querySelector('[data-pad-base-status]');
    const original=Array.from(grid.children),cardClass=grid.querySelector('.product-index')?.className||'span-3 md-span-4 sm-span-6 auto product-index';
    const pagination=Array.from(owner.querySelectorAll('.pagination'));
    const storageKey='hsbd-pad-base:'+location.pathname;
    let allCards,loading,revision=0;
    async function loadAll() {
      const result=[];let pages=1;
      for(let page=1;page<=pages;page++) {
        const url=new URL(location.href);url.hash='';url.searchParams.set('view','hsbd-pad-base-feed');url.searchParams.set('page',String(page));url.searchParams.delete('section_id');
        const response=await fetch(url.toString(),{credentials:'same-origin',cache:'no-store'});
        if(!response.ok) throw new Error('Pad results unavailable');
        const fragment=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-pad-base-feed]');
        if(!fragment) throw new Error('Pad results missing');
        pages=Number(fragment.dataset.pages);
        if(!Number.isInteger(pages)||pages<0) throw new Error('Invalid pad pagination');
        fragment.querySelectorAll('[data-pad-feed-card]').forEach(card=>{card.className=cardClass;result.push(card)});
      }
      return result;
    }
    async function apply() {
      const token=++revision,base=select.value;
      try {sessionStorage.setItem(storageKey,base)} catch(error) {}
      if(base==='all') {owner.classList.remove('hsbd-pad-base-filtered');grid.replaceChildren(...original);grid.hidden=false;pagination.forEach(node=>node.hidden=false);status.textContent='';return}
      owner.classList.add('hsbd-pad-base-filtered');
      grid.hidden=true;status.textContent=control.dataset.loading;pagination.forEach(node=>node.hidden=true);
      try {
        if(!allCards) {if(!loading)loading=loadAll().finally(()=>{loading=null});allCards=await loading}
        if(token!==revision||!control.isConnected) return;
        const matches=allCards.filter(card=>card.dataset.padBase===base);
        grid.replaceChildren(...matches);grid.hidden=false;status.textContent=matches.length+' '+control.dataset.results;
      } catch(error) {
        if(token!==revision) return;
        owner.classList.remove('hsbd-pad-base-filtered');select.value='all';try {sessionStorage.setItem(storageKey,'all')}catch(storageError){}grid.replaceChildren(...original);grid.hidden=false;pagination.forEach(node=>node.hidden=false);status.textContent=control.dataset.error;
      }
    }
    select.addEventListener('change',apply);
    try {const saved=sessionStorage.getItem(storageKey);if(['black','brown','colored'].includes(saved)){select.value=saved;apply()}}catch(error){}
  });
}
function hsbdWatchNativePadBase() {
  hsbdInitNativePadBase();
  new MutationObserver(()=>hsbdInitNativePadBase()).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',hsbdWatchNativePadBase);else hsbdWatchNativePadBase();
document.addEventListener('shopify:section:load',event=>hsbdInitNativePadBase(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-panel-cart-sync"] && !Shopify.designMode) return;
  try {
    (function () {
  let active = 0;
  let failed = false;
  let engine;
  const pending = new WeakMap();
  const panelVariantId = 45579274813593;

  function copy() { return document.getElementById('hsbd-finishing-recovery-copy')?.dataset || {}; }
  function config() { return JSON.parse(document.getElementById('cart-config')?.textContent || '{}'); }
  function knownKeys() {
    return Array.from(document.querySelectorAll('[data-hsbd-panel-shirt]')).map(row => row.dataset.hsbdPanelShirt);
  }
  async function request(path, body) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    } : undefined);
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || copy().error);
    return result;
  }
  function getEngine() {
    if (!engine) engine = window.createHsbdFinishingRecovery(request, () => {
      if (window.crypto.randomUUID) return window.crypto.randomUUID();
      return Array.from(window.crypto.getRandomValues(new Uint32Array(4)), n => n.toString(16)).join('-');
    });
    return engine;
  }
  function clearNotices() {
    document.querySelectorAll('.hsbd-panel-cart-error').forEach(notice => notice.remove());
  }
  function showError() {
    document.querySelectorAll('.js-cart-form').forEach(form => {
      let notice = form.querySelector('.hsbd-panel-cart-error');
      if (!notice) {
        notice = document.createElement('div');
        notice.className = 'hsbd-panel-cart-error span-12';
        notice.setAttribute('role', 'alert');
        const text = document.createElement('p');
        text.textContent = copy().error;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'button';
        button.dataset.hsbdRepairFees = 'true';
        button.textContent = copy().recover;
        notice.append(text, button);
        form.prepend(notice);
      }
      notice.querySelector('button').disabled = active > 0;
    });
  }
  function audit(cart) {
    failed = getEngine().inspect(cart, knownKeys()).length > 0;
    if (failed) showError(); else clearNotices();
    return !failed;
  }
  function render(cart) {
    window.Shopify.theme.ajaxCart.updateView(config(), cart);
    audit(cart);
    document.dispatchEvent(new CustomEvent('hsbd:cart-updated', { detail: { cart } }));
  }
  function busy(delta) {
    active += delta;
    document.querySelectorAll('.js-cart-form').forEach(form => {
      if (active) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
    });
    if (failed) showError();
  }
  function inputFromForm(form) {
    const data = new FormData(form);
    const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: {} };
    for (const [name, value] of data.entries()) {
      const property = /^properties\[(.*)\]$/.exec(name);
      if (!property) continue;
      if (typeof value !== 'string') throw new Error(copy().error);
      item.properties[property[1]] = value;
    }
    if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
    return item;
  }
  function showProductError(form, error) {
    let notice = form.querySelector('.hsbd-finishing-product-error');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'hsbd-finishing-product-error';
      notice.setAttribute('role', 'alert');
      form.append(notice);
    }
    notice.replaceChildren(document.createTextNode(error?.hsbdSelectionChanged ? copy().changed : copy().error));
    const link = document.createElement('a');
    link.href = config().cart_url || '/cart';
    link.textContent = copy().review;
    notice.append(document.createTextNode(' '), link);
  }
  async function addFromForm(form) {
    const input = inputFromForm(form);
    let state = pending.get(form);
    if (state && state.signature !== JSON.stringify(input)) {
      const error = new Error(copy().changed);
      error.hsbdSelectionChanged = true;
      throw error;
    }
    if (Number(form.querySelector('.js-hsbd-panty-panel')?.dataset.addonVariantId) !== panelVariantId) {
      throw new Error(copy().error);
    }
    if (!state) {
      state = { signature: JSON.stringify(input), attempt: getEngine().begin(input) };
      pending.set(form, state);
    }
    busy(1);
    try {
      const result = await getEngine().submit(state.attempt);
      pending.delete(form);
      form.querySelector('.hsbd-finishing-product-error')?.remove();
      audit(result.cart);
      return result.item;
    } catch (error) {
      failed = true;
      try { render(await request('cart.js')); } catch (_) { showError(); }
      throw error;
    } finally { busy(-1); }
  }
  async function repair() {
    if (active) return;
    busy(1);
    try {
      let cart = await request('cart.js');
      const initialIssues = getEngine().inspect(cart, knownKeys());
      for (const issue of initialIssues) {
        if (issue.reason === 'orphan_fee') {
          await request('cart/change.js', { id: issue.key, quantity: 0 });
          cart = await request('cart.js');
        } else {
          const shirt = cart.items.find(item => item.key === issue.key);
          if (shirt) cart = await getEngine().reconcile(cart, shirt);
        }
      }
      render(cart);
    } catch (_) {
      failed = true;
      try { render(await request('cart.js')); } catch (_) { showError(); }
    } finally { busy(-1); }
  }
  function handleQuantity(event) {
    const target = event.target instanceof Element ? event.target : null;
    const repairButton = target?.closest('[data-hsbd-repair-fees]');
    if (repairButton && event.type === 'click') {
      event.preventDefault(); event.stopImmediatePropagation();
      repair();
      return;
    }
    const control = target?.closest('[data-ajax-qty-increase], [data-ajax-qty-decrease], .js-cart-remove, [data-role="product-remove"], [data-item-qty]');
    const row = control?.closest('[data-hsbd-panel-shirt]');
    if (!row) return;
    if (event.type === 'click' && control.matches('[data-item-qty]')) return;
    if (event.type === 'change' && !control.matches('[data-item-qty]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (active) return;
    const input = row.querySelector('[data-item-qty]');
    let quantity = Number(input?.value);
    if (control.matches('.js-cart-remove, [data-role="product-remove"]')) quantity = 0;
    else if (control.matches('[data-ajax-qty-increase]')) quantity++;
    else if (control.matches('[data-ajax-qty-decrease]')) quantity--;
    if (!Number.isInteger(quantity) || quantity < 0) return;
    busy(1);
    getEngine().changeQuantity(row.dataset.hsbdPanelShirt, quantity).then(render).catch(async () => {
      failed = true;
      try { render(await request('cart.js')); } catch (_) { showError(); }
    }).finally(() => busy(-1));
  }
  window.HSBDPanelCart = { addFromForm, hasPending: form => pending.has(form), showProductError };
  window.addEventListener('click', handleQuantity, true);
  window.addEventListener('change', handleQuantity, true);
  window.addEventListener('submit', event => {
    if ((active || failed) && event.target.matches('.js-cart-form')) {
      event.preventDefault(); event.stopImmediatePropagation(); showError();
    }
  }, true);
  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const checkout = target?.closest('[name="checkout"], a[href*="/checkout"]');
    if ((active || failed) && checkout?.closest('.js-cart-form, .js-cart-content')) {
      event.preventDefault(); event.stopImmediatePropagation(); showError();
    }
  }, true);
  document.addEventListener('hsbd:cart-updated', event => {
    if (event.detail?.cart) audit(event.detail.cart);
  });
  async function initialAudit() {
    if (!document.querySelector('[data-hsbd-panel-shirt], [data-hsbd-panel-fee]')) return;
    busy(1);
    try { audit(await request('cart.js')); }
    catch (_) { failed = true; showError(); }
    finally { busy(-1); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialAudit, { once: true });
  else initialAudit();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-preloved-menu-link"] && !Shopify.designMode) return;
  try {
    const hsbdPrelovedChecks = new Map();
async function hsbdHasPrelovedStock(endpoint) {
  let page = 1;
  let pages = 1;
  do {
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('page', String(page));
    const response = await fetch(url.toString(), {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Stock availability could not load');
    const data = await response.json();
    if (typeof data.has_stock !== 'boolean' || !Number.isInteger(data.pages) || data.pages < 0) throw new Error('Invalid stock response');
    if (data.has_stock) return true;
    pages = data.pages;
    page += 1;
  } while (page <= pages);
  return false;
}
function hsbdRefreshPrelovedLinks(root = document) {
  const links = [...root.querySelectorAll('[data-hsbd-preloved]')];
  if (root.matches && root.matches('[data-hsbd-preloved]')) links.push(root);
  links.forEach(link => {
    const endpoint = link.dataset.stockEndpoint;
    if (!hsbdPrelovedChecks.has(endpoint)) hsbdPrelovedChecks.set(endpoint, hsbdHasPrelovedStock(endpoint).catch(() => null));
    hsbdPrelovedChecks.get(endpoint).then(hasStock => {
      link.hidden = hasStock !== true;
      link.dataset.stockStatus = hasStock === null ? 'unavailable' : hasStock ? 'in-stock' : 'empty';
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshPrelovedLinks());
else hsbdRefreshPrelovedLinks();
document.addEventListener('shopify:section:load', event => hsbdRefreshPrelovedLinks(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-preorder-exclusion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
  const input=event.target;
  if(!(input instanceof HTMLInputElement)||!input.matches('[data-hsbd-preorder-exclusion]'))return;
  event.stopImmediatePropagation();
  const url=new URL(location.href);
  const stockKey='filter.p.m.custom.has_in_stock_variants';
  const physicalKey='filter.p.m.custom.physical_stock_sizes';
  const nativeKey='filter.v.option.size';
  if(input.checked)url.searchParams.set(stockKey,'1');
  else {
    url.searchParams.delete(stockKey);
    const physical=url.searchParams.getAll(physicalKey);
    const reverse=new Map(Array.from(document.querySelectorAll('[data-hsbd-stock-size-routing] [data-source-size]'),entry=>[entry.dataset.physicalSize,entry.dataset.sourceSize]));
    url.searchParams.delete(physicalKey);
    physical.forEach(size=>url.searchParams.append(nativeKey,reverse.get(size)||size));
  }
  url.searchParams.delete('page');
  location.assign(url.href);
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-refined-layout"] && !Shopify.designMode) return;
  try {
    (function () {
  function updateFinishing(root) {
    const shoulder = root.querySelector('.hsbd-finishing-options select:not(.js-hsbd-panty-panel)');
    const panel = root.querySelector('.js-hsbd-panty-panel');
    const summary = root.querySelector('.hsbd-finishing-summary');
    if (!shoulder || !panel || !summary) return;
    const selected = shoulder.options[shoulder.selectedIndex].text.replace(' (Standard)', '');
    const panelButton = root.querySelector('[data-hsbd-panel-choice="YES"]');
    summary.textContent = (selected === 'None' ? 'No shoulder pads' : selected + ' shoulder pads') + (panel.value === 'YES' ? ' · Panty panel ' + panelButton.textContent.replace(/^Yes\s*/i, '') : '');
    root.querySelectorAll('[data-hsbd-panel-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hsbdPanelChoice === panel.value)));
    const warning = root.querySelector('.hsbd-panel-warning');
    if (warning) warning.hidden = panel.value !== 'YES';
  }
  function init(scope) {
    scope.querySelectorAll('.hsbd-refined').forEach(root => {
      root.querySelectorAll('.hsbd-finishing-disclosure').forEach(updateFinishing);
      if (root.dataset.refinedReady) return;
      root.dataset.refinedReady = 'true';
      function placeWishlist() {
        const financing = root.querySelector('#product-form-installment');
        const wishlist = root.querySelector('.Vtl-WishlistButtonWrapper');
        if (financing && wishlist && financing.nextElementSibling !== wishlist) financing.after(wishlist);
      }
      placeWishlist();
      const appObserver = new MutationObserver(placeWishlist);
      appObserver.observe(root, { childList: true, subtree: true });
      root.addEventListener('click', event => {
        const choice = event.target.closest('[data-hsbd-panel-choice]');
        if (!choice) return;
        const select = choice.closest('.hsbd-finishing-disclosure')?.querySelector('.js-hsbd-panty-panel');
        if (!select) return;
        select.value = choice.dataset.hsbdPanelChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      root.addEventListener('change', event => {
        const disclosure = event.target.closest('.hsbd-finishing-disclosure');
        if (disclosure) updateFinishing(disclosure);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-simply-stock-shelf-pre-home-hue-20261008T0138Z"] && !Shopify.designMode) return;
  try {
    const hsbdStockPageRequests = new Map();
function hsbdOrderStockShelfCards(shelf) {
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  if (!track) return;
  let members;
  try { members = JSON.parse(shelf.dataset.stockMembers || 'null'); } catch (error) { return; }
  if (!Array.isArray(members) || !members.length) return;
  const rank = new Map(members.map(function(id, index) { return [String(id), index]; }));
  const wasAtStart = track.scrollLeft <= 1;
  const cards = Array.from(track.querySelectorAll('.hsbd-stock-shelf__card[data-product-id]'));
  cards.sort(function(a, b) {
    const rankA = rank.has(String(a.dataset.productId)) ? rank.get(String(a.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    const rankB = rank.has(String(b.dataset.productId)) ? rank.get(String(b.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });
  cards.forEach(function(card) { track.appendChild(card); });
  if (wasAtStart) track.scrollLeft = 0;
}
async function hsbdCompleteStockShelf(shelf) {
  const pages = Number(shelf.dataset.stockPages);
  if (pages <= 1 || shelf.dataset.stockLoadState) return;
  shelf.dataset.stockLoadState = 'loading';
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  const status = shelf.querySelector('.hsbd-stock-shelf__partial');
  if (!track) return;
  track.setAttribute('aria-busy', 'true');
  if (status) status.textContent = shelf.dataset.stockLoading;
  try {
    const members = JSON.parse(shelf.dataset.stockMembers || 'null');
    const allowed = Array.isArray(members) ? new Set(members.map(String)) : null;
    const ids = new Set([...track.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const base = new URL(shelf.dataset.stockFeedUrl, location.origin);
    const current = new URL(location.href);
    if (base.origin !== current.origin || pages > 100) throw new Error('Invalid stock source');
    if (current.pathname === base.pathname && current.searchParams.has('sort_by')) base.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    base.searchParams.set('view', 'hsbd-stock-feed');
    for (let page = 2; page <= pages; page++) {
      if (!shelf.isConnected) return;
      base.searchParams.set('page', String(page));
      const key = base.href;
      if (!hsbdStockPageRequests.has(key)) {
        const request = fetch(key, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)})
          .then(response => {
            if (!response.ok) throw new Error('Stock source unavailable');
            return response.text();
          });
        hsbdStockPageRequests.set(key, request);
        request.catch(() => hsbdStockPageRequests.delete(key));
      }
      const html = await hsbdStockPageRequests.get(key);
      if (!shelf.isConnected) return;
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hsbd-stock-feed]');
      if (!fragment || Number(fragment.dataset.page) !== page || Number(fragment.dataset.pages) !== pages) throw new Error('Stock pagination changed');
      const batch = document.createDocumentFragment();
      for (const card of fragment.querySelectorAll('.hsbd-stock-shelf__card')) {
        const id = card.dataset.productId;
        const eligible = shelf.dataset.preorderOnly === 'true' ? card.dataset.preorder === 'true' : card.dataset.stocked === 'true';
        if (!eligible || ids.has(id) || (allowed && !allowed.has(id))) continue;
        ids.add(id);
        batch.append(document.importNode(card, true));
      }
      track.append(batch);
      hsbdOrderStockShelfCards(shelf);
      shelf.dataset.stockedCount = String(ids.size);
      shelf.dataset.scannedCount = String(Number(shelf.dataset.scannedCount) + Number(fragment.dataset.scanned));
      hsbdRefreshStockControls(shelf.parentElement);
    }
    shelf.dataset.stockLoadState = 'complete';
    if (status) status.hidden = true;
    if (!ids.size) shelf.hidden = true;
  } catch (error) {
    shelf.dataset.stockLoadState = 'incomplete';
    if (status) status.textContent = shelf.dataset.stockIncomplete;
  } finally {
    track.removeAttribute('aria-busy');
  }
}
function hsbdRefreshStockControls(root = document) {
  root.querySelectorAll('.hsbd-stock-shelf').forEach(shelf => {
    hsbdOrderStockShelfCards(shelf);
    const track = shelf.querySelector('.hsbd-stock-shelf__track');
    const previous = shelf.querySelector('[data-stock-scroll="-1"]');
    const next = shelf.querySelector('[data-stock-scroll="1"]');
    if (!track || !previous || !next) return;
    const refresh = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.controlsReady) {
      track.dataset.controlsReady = 'true';
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
    }
    refresh();
    hsbdCompleteStockShelf(shelf);
  });
}
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-stock-scroll]');
  if (!button) return;
  const track = button.closest('.hsbd-stock-shelf')?.querySelector('.hsbd-stock-shelf__track');
  if (track) track.scrollBy({ left: Number(button.dataset.stockScroll) * track.clientWidth * .9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshStockControls());
else hsbdRefreshStockControls();
document.addEventListener('shopify:section:load', event => hsbdRefreshStockControls(event.target));
document.addEventListener('focusin', function(event) {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.hsbd-stock-shelf__card');
  if (!card) return;
  window.requestAnimationFrame(function() {
    if (!card.isConnected || !card.contains(document.activeElement)) return;
    const track = card.closest('.hsbd-stock-shelf__track');
    if (!track) return;
    const cardBounds = card.getBoundingClientRect();
    const trackBounds = track.getBoundingClientRect();
    const trackLeft = trackBounds.left + track.clientLeft;
    const trackRight = trackLeft + track.clientWidth;
    if (cardBounds.width > track.clientWidth) return;
    let distance = 0;
    if (cardBounds.left < trackLeft) distance = cardBounds.left - trackLeft;
    else if (cardBounds.right > trackRight) distance = cardBounds.right - trackRight;
    if (Math.abs(distance) > 1) track.scrollBy({left: distance, behavior: 'auto'});
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-simply-stock-shelf"] && !Shopify.designMode) return;
  try {
    const hsbdStockPageRequests = new Map();
const hsbdHueTerms = [
  ['matte black',0,0],['black',0,0],['dark charcoal',0,1],['charcoal',0,2],['gunmetal',0,3],['silver',0,4],['espresso',0,7],['deep chocolate',0,8],['dark chocolate',0,9],['chocolate',0,10],['buckskin',0,12],['tan',0,14],['sand',0,15],['caramel',0,16],['off white',0,19],['white',0,20],['pale cream',0,21],['cream',0,22],
  ['dark burgundy',1,0],['iridescent burgundy',1,1],['fig burgundy',1,2],['merlot',1,3],['garnet',1,4],['cranberry',1,5],['dark berry',1,6],['bright red',1,8],['classic red',1,9],['red',1,10],
  ['electric magenta',2,0],['hot raspberry',2,0],['fuchsia',2,2],['dragonfruit',2,4],['bubblegum',2,5],['pink',2,6],['dusty rose',2,7],['rose gold',2,8],['pale blush',2,9],
  ['copper',3,1],['marmalade',3,3],['tangerine',3,4],['orange dream',3,5],['orange',3,6],['hot coral',3,7],['melon',3,9],['georgia peach',3,10],
  ['bronze',4,0],['gold',4,1],
  ['forest green',5,0],['hunter green',5,1],['dark sage',5,2],['emerald',5,3],['olive grove',5,4],['bright olive',5,5],['olive',5,6],['avocado',5,7],['kelly green',5,8],['jade',5,9],['sage green',5,10],['sage',5,10],['lime',5,12],['seafoam',5,13],
  ['dark teal',6,0],['deep navy',6,1],['dark navy',6,2],['royal navy',6,3],['navy',6,4],['indigo',6,5],['dark denim',6,6],['denim',6,7],['steel blue',6,8],['royal blue',6,9],['icey blue',6,10],['periwinkle',6,11],['rich turquoise',6,12],['turquoise',6,13],['teal',6,14],['aqua',6,15],['blue',6,16],
  ['eggplant',7,0],['aubergine',7,1],['grape jelly',7,2],['royal purple',7,3],['electric purple',7,4],['iridescent purple',7,5],['orchid',7,7],['dark lavender',7,8],['icey lavender',7,9],['lavender',7,10],['lilac',7,11],['soft purple',7,12]
];
function hsbdHueRank(card) {
  const title = String(card.dataset.productTitle || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  let best = null;
  hsbdHueTerms.forEach(function(term, order) {
    const index = title.indexOf(term[0]);
    if (index < 0) return;
    const candidate = [index, -term[0].length, term[1], term[2], order];
    if (!best || candidate[0] < best[0] || (candidate[0] === best[0] && candidate[1] < best[1])) best = candidate;
  });
  return best ? [best[2], best[3], title] : [99, 99, title];
}
function hsbdOrderStockShelfCards(shelf) {
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  if (!track) return;
  let members;
  try { members = JSON.parse(shelf.dataset.stockMembers || 'null'); } catch (error) { members = null; }
  const hasMemberOrder = Array.isArray(members) && members.length;
  const useHueOrder = shelf.dataset.stockSort === 'hue';
  const prioritizeReady = shelf.dataset.prioritizeReady === 'true';
  if (!hasMemberOrder && !useHueOrder && !prioritizeReady) return;
  const rank = new Map((hasMemberOrder ? members : []).map(function(id, index) { return [String(id), index]; }));
  const wasAtStart = track.scrollLeft <= 1;
  const cards = Array.from(track.querySelectorAll('.hsbd-stock-shelf__card[data-product-id]'));
  cards.sort(function(a, b) {
    if (prioritizeReady && a.dataset.ready !== b.dataset.ready) return a.dataset.ready === 'true' ? -1 : 1;
    if (hasMemberOrder) {
      const rankA = rank.has(String(a.dataset.productId)) ? rank.get(String(a.dataset.productId)) : Number.MAX_SAFE_INTEGER;
      const rankB = rank.has(String(b.dataset.productId)) ? rank.get(String(b.dataset.productId)) : Number.MAX_SAFE_INTEGER;
      return rankA - rankB;
    }
    const rankA = hsbdHueRank(a);
    const rankB = hsbdHueRank(b);
    return rankA[0] - rankB[0] || rankA[1] - rankB[1] || rankA[2].localeCompare(rankB[2]);
  });
  cards.forEach(function(card) { track.appendChild(card); });
  if (wasAtStart) track.scrollLeft = 0;
}
async function hsbdCompleteStockShelf(shelf) {
  const pages = Number(shelf.dataset.stockPages);
  if (pages <= 1 || shelf.dataset.stockLoadState) return;
  shelf.dataset.stockLoadState = 'loading';
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  const status = shelf.querySelector('.hsbd-stock-shelf__partial');
  if (!track) return;
  track.setAttribute('aria-busy', 'true');
  if (status) status.textContent = shelf.dataset.stockLoading;
  try {
    const members = JSON.parse(shelf.dataset.stockMembers || 'null');
    const allowed = Array.isArray(members) ? new Set(members.map(String)) : null;
    const ids = new Set([...track.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const base = new URL(shelf.dataset.stockFeedUrl, location.origin);
    const current = new URL(location.href);
    if (base.origin !== current.origin || pages > 100) throw new Error('Invalid stock source');
    if (current.pathname === base.pathname && current.searchParams.has('sort_by')) base.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    base.searchParams.set('view', 'hsbd-stock-feed');
    for (let page = 2; page <= pages; page++) {
      if (!shelf.isConnected) return;
      base.searchParams.set('page', String(page));
      const key = base.href;
      if (!hsbdStockPageRequests.has(key)) {
        const request = fetch(key, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)})
          .then(response => {
            if (!response.ok) throw new Error('Stock source unavailable');
            return response.text();
          });
        hsbdStockPageRequests.set(key, request);
        request.catch(() => hsbdStockPageRequests.delete(key));
      }
      const html = await hsbdStockPageRequests.get(key);
      if (!shelf.isConnected) return;
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hsbd-stock-feed]');
      if (!fragment || Number(fragment.dataset.page) !== page || Number(fragment.dataset.pages) !== pages) throw new Error('Stock pagination changed');
      const batch = document.createDocumentFragment();
      for (const card of fragment.querySelectorAll('.hsbd-stock-shelf__card')) {
        const id = card.dataset.productId;
        const eligible = shelf.dataset.preorderOnly === 'true' ? card.dataset.preorder === 'true' : card.dataset.stocked === 'true';
        if (!eligible || ids.has(id) || (allowed && !allowed.has(id))) continue;
        ids.add(id);
        batch.append(document.importNode(card, true));
      }
      track.append(batch);
      hsbdOrderStockShelfCards(shelf);
      shelf.dataset.stockedCount = String(ids.size);
      shelf.dataset.scannedCount = String(Number(shelf.dataset.scannedCount) + Number(fragment.dataset.scanned));
      hsbdRefreshStockControls(shelf.parentElement);
    }
    shelf.dataset.stockLoadState = 'complete';
    if (status) status.hidden = true;
    if (!ids.size) shelf.hidden = true;
  } catch (error) {
    shelf.dataset.stockLoadState = 'incomplete';
    if (status) status.textContent = shelf.dataset.stockIncomplete;
  } finally {
    track.removeAttribute('aria-busy');
  }
}
function hsbdRefreshStockControls(root = document) {
  root.querySelectorAll('.hsbd-stock-shelf').forEach(shelf => {
    hsbdOrderStockShelfCards(shelf);
    const track = shelf.querySelector('.hsbd-stock-shelf__track');
    const previous = shelf.querySelector('[data-stock-scroll="-1"]');
    const next = shelf.querySelector('[data-stock-scroll="1"]');
    if (!track || !previous || !next) return;
    const refresh = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.controlsReady) {
      track.dataset.controlsReady = 'true';
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
    }
    refresh();
    hsbdCompleteStockShelf(shelf);
  });
}
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-stock-scroll]');
  if (!button) return;
  const track = button.closest('.hsbd-stock-shelf')?.querySelector('.hsbd-stock-shelf__track');
  if (track) track.scrollBy({ left: Number(button.dataset.stockScroll) * track.clientWidth * .9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshStockControls());
else hsbdRefreshStockControls();
document.addEventListener('shopify:section:load', event => hsbdRefreshStockControls(event.target));
document.addEventListener('focusin', function(event) {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.hsbd-stock-shelf__card');
  if (!card) return;
  window.requestAnimationFrame(function() {
    if (!card.isConnected || !card.contains(document.activeElement)) return;
    const track = card.closest('.hsbd-stock-shelf__track');
    if (!track) return;
    const cardBounds = card.getBoundingClientRect();
    const trackBounds = track.getBoundingClientRect();
    const trackLeft = trackBounds.left + track.clientLeft;
    const trackRight = trackLeft + track.clientWidth;
    if (cardBounds.width > track.clientWidth) return;
    let distance = 0;
    if (cardBounds.left < trackLeft) distance = cardBounds.left - trackLeft;
    else if (cardBounds.right > trackRight) distance = cardBounds.right - trackRight;
    if (Math.abs(distance) > 1) track.scrollBy({left: distance, behavior: 'auto'});
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-simply-stock-shelf.pre-carousel-start-20261008T0115Z"] && !Shopify.designMode) return;
  try {
    const hsbdStockPageRequests = new Map();
function hsbdOrderStockShelfCards(shelf) {
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  if (!track) return;
  let members;
  try { members = JSON.parse(shelf.dataset.stockMembers || 'null'); } catch (error) { return; }
  if (!Array.isArray(members) || !members.length) return;
  const rank = new Map(members.map(function(id, index) { return [String(id), index]; }));
  const cards = Array.from(track.querySelectorAll('.hsbd-stock-shelf__card[data-product-id]'));
  cards.sort(function(a, b) {
    const rankA = rank.has(String(a.dataset.productId)) ? rank.get(String(a.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    const rankB = rank.has(String(b.dataset.productId)) ? rank.get(String(b.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });
  cards.forEach(function(card) { track.appendChild(card); });
}
async function hsbdCompleteStockShelf(shelf) {
  const pages = Number(shelf.dataset.stockPages);
  if (pages <= 1 || shelf.dataset.stockLoadState) return;
  shelf.dataset.stockLoadState = 'loading';
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  const status = shelf.querySelector('.hsbd-stock-shelf__partial');
  if (!track) return;
  track.setAttribute('aria-busy', 'true');
  if (status) status.textContent = shelf.dataset.stockLoading;
  try {
    const members = JSON.parse(shelf.dataset.stockMembers || 'null');
    const allowed = Array.isArray(members) ? new Set(members.map(String)) : null;
    const ids = new Set([...track.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const base = new URL(shelf.dataset.stockFeedUrl, location.origin);
    const current = new URL(location.href);
    if (base.origin !== current.origin || pages > 100) throw new Error('Invalid stock source');
    if (current.pathname === base.pathname && current.searchParams.has('sort_by')) base.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    base.searchParams.set('view', 'hsbd-stock-feed');
    for (let page = 2; page <= pages; page++) {
      if (!shelf.isConnected) return;
      base.searchParams.set('page', String(page));
      const key = base.href;
      if (!hsbdStockPageRequests.has(key)) {
        const request = fetch(key, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)})
          .then(response => {
            if (!response.ok) throw new Error('Stock source unavailable');
            return response.text();
          });
        hsbdStockPageRequests.set(key, request);
        request.catch(() => hsbdStockPageRequests.delete(key));
      }
      const html = await hsbdStockPageRequests.get(key);
      if (!shelf.isConnected) return;
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hsbd-stock-feed]');
      if (!fragment || Number(fragment.dataset.page) !== page || Number(fragment.dataset.pages) !== pages) throw new Error('Stock pagination changed');
      const batch = document.createDocumentFragment();
      for (const card of fragment.querySelectorAll('.hsbd-stock-shelf__card')) {
        const id = card.dataset.productId;
        const eligible = shelf.dataset.preorderOnly === 'true' ? card.dataset.preorder === 'true' : card.dataset.stocked === 'true';
        if (!eligible || ids.has(id) || (allowed && !allowed.has(id))) continue;
        ids.add(id);
        batch.append(document.importNode(card, true));
      }
      track.append(batch);
      hsbdOrderStockShelfCards(shelf);
      shelf.dataset.stockedCount = String(ids.size);
      shelf.dataset.scannedCount = String(Number(shelf.dataset.scannedCount) + Number(fragment.dataset.scanned));
      hsbdRefreshStockControls(shelf.parentElement);
    }
    shelf.dataset.stockLoadState = 'complete';
    if (status) status.hidden = true;
    if (!ids.size) shelf.hidden = true;
  } catch (error) {
    shelf.dataset.stockLoadState = 'incomplete';
    if (status) status.textContent = shelf.dataset.stockIncomplete;
  } finally {
    track.removeAttribute('aria-busy');
  }
}
function hsbdRefreshStockControls(root = document) {
  root.querySelectorAll('.hsbd-stock-shelf').forEach(shelf => {
    hsbdOrderStockShelfCards(shelf);
    const track = shelf.querySelector('.hsbd-stock-shelf__track');
    const previous = shelf.querySelector('[data-stock-scroll="-1"]');
    const next = shelf.querySelector('[data-stock-scroll="1"]');
    if (!track || !previous || !next) return;
    const refresh = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.controlsReady) {
      track.dataset.controlsReady = 'true';
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
    }
    refresh();
    hsbdCompleteStockShelf(shelf);
  });
}
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-stock-scroll]');
  if (!button) return;
  const track = button.closest('.hsbd-stock-shelf')?.querySelector('.hsbd-stock-shelf__track');
  if (track) track.scrollBy({ left: Number(button.dataset.stockScroll) * track.clientWidth * .9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshStockControls());
else hsbdRefreshStockControls();
document.addEventListener('shopify:section:load', event => hsbdRefreshStockControls(event.target));
document.addEventListener('focusin', function(event) {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.hsbd-stock-shelf__card');
  if (!card) return;
  window.requestAnimationFrame(function() {
    if (!card.isConnected || !card.contains(document.activeElement)) return;
    const track = card.closest('.hsbd-stock-shelf__track');
    if (!track) return;
    const cardBounds = card.getBoundingClientRect();
    const trackBounds = track.getBoundingClientRect();
    const trackLeft = trackBounds.left + track.clientLeft;
    const trackRight = trackLeft + track.clientWidth;
    if (cardBounds.width > track.clientWidth) return;
    let distance = 0;
    if (cardBounds.left < trackLeft) distance = cardBounds.left - trackLeft;
    else if (cardBounds.right > trackRight) distance = cardBounds.right - trackRight;
    if (Math.abs(distance) > 1) track.scrollBy({left: distance, behavior: 'auto'});
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-simply-stock-shelf.pre-category-hue-order-20261008T0135Z"] && !Shopify.designMode) return;
  try {
    const hsbdStockPageRequests = new Map();
function hsbdOrderStockShelfCards(shelf) {
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  if (!track) return;
  let members;
  try { members = JSON.parse(shelf.dataset.stockMembers || 'null'); } catch (error) { return; }
  if (!Array.isArray(members) || !members.length) return;
  const rank = new Map(members.map(function(id, index) { return [String(id), index]; }));
  const wasAtStart = track.scrollLeft <= 1;
  const cards = Array.from(track.querySelectorAll('.hsbd-stock-shelf__card[data-product-id]'));
  cards.sort(function(a, b) {
    const rankA = rank.has(String(a.dataset.productId)) ? rank.get(String(a.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    const rankB = rank.has(String(b.dataset.productId)) ? rank.get(String(b.dataset.productId)) : Number.MAX_SAFE_INTEGER;
    return rankA - rankB;
  });
  cards.forEach(function(card) { track.appendChild(card); });
  if (wasAtStart) track.scrollLeft = 0;
}
async function hsbdCompleteStockShelf(shelf) {
  const pages = Number(shelf.dataset.stockPages);
  if (pages <= 1 || shelf.dataset.stockLoadState) return;
  shelf.dataset.stockLoadState = 'loading';
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  const status = shelf.querySelector('.hsbd-stock-shelf__partial');
  if (!track) return;
  track.setAttribute('aria-busy', 'true');
  if (status) status.textContent = shelf.dataset.stockLoading;
  try {
    const members = JSON.parse(shelf.dataset.stockMembers || 'null');
    const allowed = Array.isArray(members) ? new Set(members.map(String)) : null;
    const ids = new Set([...track.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const base = new URL(shelf.dataset.stockFeedUrl, location.origin);
    const current = new URL(location.href);
    if (base.origin !== current.origin || pages > 100) throw new Error('Invalid stock source');
    if (current.pathname === base.pathname && current.searchParams.has('sort_by')) base.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    base.searchParams.set('view', 'hsbd-stock-feed');
    for (let page = 2; page <= pages; page++) {
      if (!shelf.isConnected) return;
      base.searchParams.set('page', String(page));
      const key = base.href;
      if (!hsbdStockPageRequests.has(key)) {
        const request = fetch(key, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)})
          .then(response => {
            if (!response.ok) throw new Error('Stock source unavailable');
            return response.text();
          });
        hsbdStockPageRequests.set(key, request);
        request.catch(() => hsbdStockPageRequests.delete(key));
      }
      const html = await hsbdStockPageRequests.get(key);
      if (!shelf.isConnected) return;
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hsbd-stock-feed]');
      if (!fragment || Number(fragment.dataset.page) !== page || Number(fragment.dataset.pages) !== pages) throw new Error('Stock pagination changed');
      const batch = document.createDocumentFragment();
      for (const card of fragment.querySelectorAll('.hsbd-stock-shelf__card')) {
        const id = card.dataset.productId;
        const eligible = shelf.dataset.preorderOnly === 'true' ? card.dataset.preorder === 'true' : card.dataset.stocked === 'true';
        if (!eligible || ids.has(id) || (allowed && !allowed.has(id))) continue;
        ids.add(id);
        batch.append(document.importNode(card, true));
      }
      track.append(batch);
      hsbdOrderStockShelfCards(shelf);
      shelf.dataset.stockedCount = String(ids.size);
      shelf.dataset.scannedCount = String(Number(shelf.dataset.scannedCount) + Number(fragment.dataset.scanned));
      hsbdRefreshStockControls(shelf.parentElement);
    }
    shelf.dataset.stockLoadState = 'complete';
    if (status) status.hidden = true;
    if (!ids.size) shelf.hidden = true;
  } catch (error) {
    shelf.dataset.stockLoadState = 'incomplete';
    if (status) status.textContent = shelf.dataset.stockIncomplete;
  } finally {
    track.removeAttribute('aria-busy');
  }
}
function hsbdRefreshStockControls(root = document) {
  root.querySelectorAll('.hsbd-stock-shelf').forEach(shelf => {
    hsbdOrderStockShelfCards(shelf);
    const track = shelf.querySelector('.hsbd-stock-shelf__track');
    const previous = shelf.querySelector('[data-stock-scroll="-1"]');
    const next = shelf.querySelector('[data-stock-scroll="1"]');
    if (!track || !previous || !next) return;
    const refresh = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.controlsReady) {
      track.dataset.controlsReady = 'true';
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
    }
    refresh();
    hsbdCompleteStockShelf(shelf);
  });
}
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-stock-scroll]');
  if (!button) return;
  const track = button.closest('.hsbd-stock-shelf')?.querySelector('.hsbd-stock-shelf__track');
  if (track) track.scrollBy({ left: Number(button.dataset.stockScroll) * track.clientWidth * .9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshStockControls());
else hsbdRefreshStockControls();
document.addEventListener('shopify:section:load', event => hsbdRefreshStockControls(event.target));
document.addEventListener('focusin', function(event) {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.hsbd-stock-shelf__card');
  if (!card) return;
  window.requestAnimationFrame(function() {
    if (!card.isConnected || !card.contains(document.activeElement)) return;
    const track = card.closest('.hsbd-stock-shelf__track');
    if (!track) return;
    const cardBounds = card.getBoundingClientRect();
    const trackBounds = track.getBoundingClientRect();
    const trackLeft = trackBounds.left + track.clientLeft;
    const trackRight = trackLeft + track.clientWidth;
    if (cardBounds.width > track.clientWidth) return;
    let distance = 0;
    if (cardBounds.left < trackLeft) distance = cardBounds.left - trackLeft;
    else if (cardBounds.right > trackRight) distance = cardBounds.right - trackRight;
    if (Math.abs(distance) > 1) track.scrollBy({left: distance, behavior: 'auto'});
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-simply-stock-shelf.pre-core-order-20261008"] && !Shopify.designMode) return;
  try {
    const hsbdStockPageRequests = new Map();
async function hsbdCompleteStockShelf(shelf) {
  const pages = Number(shelf.dataset.stockPages);
  if (pages <= 1 || shelf.dataset.stockLoadState) return;
  shelf.dataset.stockLoadState = 'loading';
  const track = shelf.querySelector('.hsbd-stock-shelf__track');
  const status = shelf.querySelector('.hsbd-stock-shelf__partial');
  if (!track) return;
  track.setAttribute('aria-busy', 'true');
  if (status) status.textContent = shelf.dataset.stockLoading;
  try {
    const members = JSON.parse(shelf.dataset.stockMembers || 'null');
    const allowed = Array.isArray(members) ? new Set(members.map(String)) : null;
    const ids = new Set([...track.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
    const base = new URL(shelf.dataset.stockFeedUrl, location.origin);
    const current = new URL(location.href);
    if (base.origin !== current.origin || pages > 100) throw new Error('Invalid stock source');
    if (current.pathname === base.pathname && current.searchParams.has('sort_by')) base.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    base.searchParams.set('view', 'hsbd-stock-feed');
    for (let page = 2; page <= pages; page++) {
      if (!shelf.isConnected) return;
      base.searchParams.set('page', String(page));
      const key = base.href;
      if (!hsbdStockPageRequests.has(key)) {
        const request = fetch(key, {credentials: 'same-origin', signal: AbortSignal.timeout(20000)})
          .then(response => {
            if (!response.ok) throw new Error('Stock source unavailable');
            return response.text();
          });
        hsbdStockPageRequests.set(key, request);
        request.catch(() => hsbdStockPageRequests.delete(key));
      }
      const html = await hsbdStockPageRequests.get(key);
      if (!shelf.isConnected) return;
      const fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hsbd-stock-feed]');
      if (!fragment || Number(fragment.dataset.page) !== page || Number(fragment.dataset.pages) !== pages) throw new Error('Stock pagination changed');
      const batch = document.createDocumentFragment();
      for (const card of fragment.querySelectorAll('.hsbd-stock-shelf__card')) {
        const id = card.dataset.productId;
        const eligible = shelf.dataset.preorderOnly === 'true' ? card.dataset.preorder === 'true' : card.dataset.stocked === 'true';
        if (!eligible || ids.has(id) || (allowed && !allowed.has(id))) continue;
        ids.add(id);
        batch.append(document.importNode(card, true));
      }
      track.append(batch);
      shelf.dataset.stockedCount = String(ids.size);
      shelf.dataset.scannedCount = String(Number(shelf.dataset.scannedCount) + Number(fragment.dataset.scanned));
      hsbdRefreshStockControls(shelf.parentElement);
    }
    shelf.dataset.stockLoadState = 'complete';
    if (status) status.hidden = true;
    if (!ids.size) shelf.hidden = true;
  } catch (error) {
    shelf.dataset.stockLoadState = 'incomplete';
    if (status) status.textContent = shelf.dataset.stockIncomplete;
  } finally {
    track.removeAttribute('aria-busy');
  }
}
function hsbdRefreshStockControls(root = document) {
  root.querySelectorAll('.hsbd-stock-shelf').forEach(shelf => {
    const track = shelf.querySelector('.hsbd-stock-shelf__track');
    const previous = shelf.querySelector('[data-stock-scroll="-1"]');
    const next = shelf.querySelector('[data-stock-scroll="1"]');
    if (!track || !previous || !next) return;
    const refresh = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    if (!track.dataset.controlsReady) {
      track.dataset.controlsReady = 'true';
      track.addEventListener('scroll', refresh, { passive: true });
      new ResizeObserver(refresh).observe(track);
    }
    refresh();
    hsbdCompleteStockShelf(shelf);
  });
}
document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-stock-scroll]');
  if (!button) return;
  const track = button.closest('.hsbd-stock-shelf')?.querySelector('.hsbd-stock-shelf__track');
  if (track) track.scrollBy({ left: Number(button.dataset.stockScroll) * track.clientWidth * .9, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hsbdRefreshStockControls());
else hsbdRefreshStockControls();
document.addEventListener('shopify:section:load', event => hsbdRefreshStockControls(event.target));
document.addEventListener('focusin', function(event) {
  if (!(event.target instanceof Element)) return;
  const card = event.target.closest('.hsbd-stock-shelf__card');
  if (!card) return;
  window.requestAnimationFrame(function() {
    if (!card.isConnected || !card.contains(document.activeElement)) return;
    const track = card.closest('.hsbd-stock-shelf__track');
    if (!track) return;
    const cardBounds = card.getBoundingClientRect();
    const trackBounds = track.getBoundingClientRect();
    const trackLeft = trackBounds.left + track.clientLeft;
    const trackRight = trackLeft + track.clientWidth;
    if (cardBounds.width > track.clientWidth) return;
    let distance = 0;
    if (cardBounds.left < trackLeft) distance = cardBounds.left - trackLeft;
    else if (cardBounds.right > trackRight) distance = cardBounds.right - trackRight;
    if (Math.abs(distance) > 1) track.scrollBy({left: distance, behavior: 'auto'});
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hsbd-stock-size-routing"] && !Shopify.designMode) return;
  try {
    (() => {
  const nativeKey = 'filter.v.option.size';
  const stockKey = 'filter.p.m.custom.has_in_stock_variants';
  const physicalKey = 'filter.p.m.custom.physical_stock_sizes';
  function normalize(href) {
    const url = new URL(href, location.href);
    if (url.origin !== location.origin) return null;
    const nativeSizes = url.searchParams.getAll(nativeKey);
    const stockMode = ['1', 'true'].includes(url.searchParams.get(stockKey)) || url.searchParams.has(physicalKey);
    const current = new URL(location.href);
    const preserveView = url.pathname === current.pathname && current.searchParams.has('view') && !url.searchParams.has('view');
    if (preserveView) url.searchParams.set('view', current.searchParams.get('view'));
    if (!stockMode || !nativeSizes.length) return preserveView ? url : null;
    const mapping = new Map(Array.from(document.querySelectorAll('[data-hsbd-stock-size-routing] [data-source-size]'), entry => [entry.dataset.sourceSize, entry.dataset.physicalSize]));
    url.searchParams.delete(nativeKey);
    const existing = new Set(url.searchParams.getAll(physicalKey));
    for (const size of nativeSizes) {
      const physicalSize = mapping.get(size) || size;
      if (!existing.has(physicalSize)) url.searchParams.append(physicalKey, physicalSize);
      existing.add(physicalSize);
    }
    url.searchParams.delete('page');
    return url;
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const link = target.closest('a.js-collection-side-filter, a.js-current-filter, a.js-hz-filter');
    const row = target.closest('.js-hz-filter li[data-add][data-remove]');
    if (row?.classList.contains('disabled')) return;
    const href = link?.getAttribute('href') || (row ? row.getAttribute(row.classList.contains('current') ? 'data-remove' : 'data-add') : null);
    if (!href) return;
    // Pad facets use server navigation because their native AJAX grid can remain stale.
    // Keep this click-only: initial URL normalization must not reload unchanged pages.
    const padCollection = /^\/collections\/(pads|show-pads|ranch-pads)\/?$/.test(location.pathname);
    const padUrl = padCollection && link ? new URL(href, location.href) : null;
    const normalized = normalize(href) || (padUrl?.origin === location.origin ? padUrl : null);
    if (!normalized) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(normalized.href);
  }, true);
  function normalizeInitialSelection() {
    const normalized = normalize(location.href);
    if (normalized) location.replace(normalized.href);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeInitialSelection, {once: true});
  else normalizeInitialSelection();
})();
  } catch(e) { console.error(e); }
})();

})();
